import { recordTestInstance } from '../axios';

const blockModule = (moduleId: string, moduleName: string, email: string, fullName: string, moduleStatus: string, customerId: string, locationId: string) =>
  recordTestInstance.post('/handle-module-lock', { moduleId, moduleName, email, fullName, moduleStatus, customerId, locationId });

export default blockModule;
